import Coolidge from '../images/Coolidge.jpg';


function CoolidgeCalvinEmbed(){
    return (
        <>
        <img src={Coolidge} alt="Calvin Coolidge Portrait" className="faithImage" />
        </>
    );
};
export default CoolidgeCalvinEmbed;